import { render, staticRenderFns } from "./DomesticBoxOfficeList.vue?vue&type=template&id=56f26650&scoped=true"
import script from "./DomesticBoxOfficeList.vue?vue&type=script&lang=js"
export * from "./DomesticBoxOfficeList.vue?vue&type=script&lang=js"
import style0 from "./DomesticBoxOfficeList.vue?vue&type=style&index=0&id=56f26650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f26650",
  null
  
)

export default component.exports